// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"_2d6B","logo":"_225E","notfoundImage":"P0zs","btn":"_2Vzu"};